import { useEffect, useRef, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { useT } from "../../i18n/I18nContext";
import { WHATSAPP_NUMBERS } from "./contacts";

export const WhatsAppFloat = () => {
  const t = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const prefill = encodeURIComponent(t.contact.whatsappPrefill);

  return (
    <div ref={ref} className="fixed bottom-6 right-6 z-50">
      {/* Popover */}
      {open && (
        <div
          data-testid="whatsapp-popover"
          className="absolute bottom-16 right-0 w-72 bg-white rounded-2xl shadow-2xl ring-1 ring-slate-200 overflow-hidden"
        >
          <div className="px-4 py-3 bg-[#0A2342] text-white flex items-center justify-between">
            <div>
              <p className="text-[11px] font-bold uppercase tracking-wider text-[#10B981]">
                WhatsApp
              </p>
              <p className="mt-0.5 text-sm font-semibold">{t.contact.whatsappCta}</p>
            </div>
            <button
              type="button"
              aria-label="Close"
              data-testid="whatsapp-popover-close"
              onClick={() => setOpen(false)}
              className="inline-flex w-7 h-7 items-center justify-center rounded-full text-white/70 hover:text-white hover:bg-white/10 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <ul className="py-2">
            {WHATSAPP_NUMBERS.map((n, idx) => (
              <li key={n.digits}>
                <a
                  href={`https://wa.me/${n.digits}?text=${prefill}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`whatsapp-popover-link-${idx}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 hover:bg-slate-50 transition-colors"
                >
                  <span className="inline-flex w-9 h-9 items-center justify-center rounded-full bg-[#10B981]/10 text-[#10B981]">
                    <MessageCircle className="w-4 h-4" />
                  </span>
                  <div className="flex-1">
                    <p className="text-sm font-bold text-[#0A2342] leading-tight">
                      {n.display}
                    </p>
                    <p className="text-xs text-slate-500 mt-0.5">
                      Tap to chat
                    </p>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      <button
        type="button"
        aria-label={open ? "Close WhatsApp menu" : "Open WhatsApp menu"}
        aria-expanded={open}
        data-testid="whatsapp-float"
        onClick={() => setOpen((v) => !v)}
        className={`relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#10B981] text-white shadow-xl hover:bg-[#059669] hover:scale-105 transition-transform duration-300 ${
          open ? "" : "uv-pulse-ring"
        }`}
      >
        {open ? <X className="w-6 h-6" strokeWidth={2.2} /> : <MessageCircle className="w-6 h-6" strokeWidth={2.2} />}
      </button>
    </div>
  );
};

export default WhatsAppFloat;
